import { Component, computed, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-score-input',
  imports: [FormsModule, CommonModule],
  templateUrl: './score-input.html',
  styleUrl: './score-input.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ScoreInput),
      multi: true,
    },
  ],
})
export class ScoreInput implements ControlValueAccessor {
  public min = input<number>(1);
  public max = input<number>(5);
  public label = input.required<string>();
  public inputId = input.required<string>();
  public step = input<number>(1);

  protected value = signal<number | null | undefined>(undefined);
  protected disabled = signal<boolean>(false);

  /**
   * Computed array of radio button options based on min, max, and step
   */
  protected radioOptions = computed(() => {
    const min = this.min();
    const max = this.max();
    const step = this.step();
    const options: number[] = [];

    for (let i = min; i <= max; i += step) {
      options.push(i);
    }

    return options;
  });

  private onChange: (value: number | null | undefined) => void = () => {
    /* intentionally empty */
  };
  private onTouched: () => void = () => {
    /* intentionally empty */
  };

  private isInitialized = false;

  writeValue(obj: number | null | undefined): void {
    if (obj !== this.value()) {
      this.value.set(obj);
    }

    // Mark as initialized after the first writeValue call to prevent onChange from firing during initial setup
    this.isInitialized = true;
  }

  registerOnChange(fn: (value: number | null | undefined) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  protected onValueChange(newValue: number): void {
    this.value.set(newValue);
    this.onChange(newValue);
  }

  protected onBlur(): void {
    this.onTouched();
  }
}
